<div class="col-sm-1 mat-form-field text-right">
    <ng-content></ng-content>
    <button class="mat-chip-remove mat-chip-trailing-icon ng-tns-c321-3" (click)="event(click, item)" type="button">
        <mat-icon role="img" class="mat-icon notranslate ng-tns-c321-3 material-icons mat-icon-no-color" data-mat-icon-type="font">{{font}}</mat-icon>
    </button>
</div>